import { Grid } from '@sequencehq/core-components'
import { PropsWithChildren } from 'react'

export const FieldGrid = ({ children }: PropsWithChildren) => (
  <Grid gridTemplateColumns="32fr 255fr 142fr 142fr" gap="8px">
    {children}
  </Grid>
)
